import HttpService from '@/api/HttpService';
import AuthService from '@/api/AuthService';

import {
  SET_STATES,
  SET_CANADA_STATES,
  SET_COUNTRIES,
  START_REGISTRATION_REQUEST,
  STOP_REGISTRATION_REQUEST,
  SET_IDLE_ON,
  SET_IDLE_OFF,
  START_LOGIN_REQUEST,
  STOP_LOGIN_REQUEST,
  SET_REDIRECT_URL,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    states: [],
    canadaStates: [],
    countries: [],
    registrationRequestIsPending: false,
    isUserIdle: false,
    loginRequestIsPending: false,
    redirectUrl: '',
  },
  mutations: {
    [SET_STATES](state, states = []) {
      state.states = states;
    },
    [SET_CANADA_STATES](state, canadaStates = []) {
      state.canadaStates = canadaStates;
    },
    [SET_COUNTRIES](state, countries = []) {
      state.countries = countries;
    },
    [START_REGISTRATION_REQUEST](state) {
      state.registrationRequestIsPending = true;
    },
    [STOP_REGISTRATION_REQUEST](state) {
      state.registrationRequestIsPending = false;
    },
    [SET_IDLE_ON](state) {
      state.isUserIdle = true;
    },
    [SET_IDLE_OFF](state) {
      state.isUserIdle = false;
    },
    [SET_REDIRECT_URL](state, url) {
      state.redirectUrl = url;
    },
    [START_LOGIN_REQUEST](state) {
      state.loginRequestIsPending = true;
    },
    [STOP_LOGIN_REQUEST](state) {
      state.loginRequestIsPending = false;
    },
  },
  actions: {
    getStates({ commit }) {
      return HttpService.get('states').then((states) => {
        commit(SET_STATES, states);
        return states;
      });
    },
    getCanadaStates({ commit }) {
      return HttpService.get('canada-states').then((canadaStates) => {
        commit(SET_CANADA_STATES, canadaStates);
        return canadaStates;
      });
    },
    getCountries({ commit }) {
      return HttpService.get('countries').then((countries) => {
        commit(SET_COUNTRIES, countries);
        return countries;
      });
    },
    register({ commit }, { email, password, state, recaptchaResponse }) {
      commit(START_REGISTRATION_REQUEST);
      return AuthService.register({
        email,
        password,
        state,
        recaptchaResponse,
      })
        .then((data) => {
          commit(STOP_REGISTRATION_REQUEST);
          return data;
        })
        .catch((e) => {
          commit(STOP_REGISTRATION_REQUEST);
          throw e;
        });
    },
    legacyLogin({ commit }, { password, legacyToken }) {
      commit(START_LOGIN_REQUEST);
      return HttpService.postV2('legacy-login', { password }, { legacyToken });
    },
    logIn({ commit }, { email, password }) {
      commit(START_LOGIN_REQUEST);
      return AuthService.logIn({ email, password })
        .then((data) => {
          commit(STOP_LOGIN_REQUEST);
          return data;
        })
        .catch((e) => {
          commit(STOP_LOGIN_REQUEST);
          throw e;
        });
    },
    handleMfa({ commit }, { mfaCode }) {
      commit(START_LOGIN_REQUEST);
      return AuthService.handleMfa({ mfaCode })
        .then((data) => {
          commit(STOP_LOGIN_REQUEST);
          return data;
        })
        .catch((e) => {
          commit(STOP_LOGIN_REQUEST);
          throw e;
        });
    },
    forgotPassword(_, { email }) {
      return HttpService.postV2('/auth/forgot-password', { email: email.toLowerCase() });
    },
    resetPassword(_, { email }) {
      return AuthService.resetPassword({ email });
    },
    verifyMigration(_, { email }) {
      return HttpService.postV2('users/verify-migration', { email });
    },
    getUserMetadata() {
      return HttpService.get('/authentication/userinfo');
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js